import Glide from "@glidejs/glide";

/**
 * var is used for variable declarations as Glide.js does not support const and let
 */
export function initialiseGliders() {

    /**
     * Glidejs has a bug that causes hrefs within a carousel to become null when the carousel moves.
     * We deal with this by extracting the initial href's within the carousel,
     * then whenever the carousel is moved, we override the bugged/null href's with the originals.
     *
     * @function getChildAnchorTagHrefs Returns an array of hrefs within the element param.
     */
    function getChildAnchorTagHrefs(element) {
        var anchorTags = element.querySelectorAll("a");
        var anchorHrefs = [];

        for (var i = 0; i < anchorTags.length; i++) {
            anchorHrefs.push(anchorTags[i].getAttribute("href"));
        }

        return anchorHrefs;
    }

    /**
     * @function replaceElementChildAnchorTagHrefs Replaces hrefs within element param with those passed via anchorTags param.
     */
    function replaceElementChildAnchorTagHrefs(element, anchorTags) {
        var buggedHrefs = element.querySelectorAll("a");

        setTimeout(() => {
            for (var i = 0; i < buggedHrefs.length; i++) {
                buggedHrefs[i].setAttribute("href", anchorTags[i]);
                buggedHrefs[i].setAttribute("data-href", anchorTags[i]);
            }
        }, 100);
    }
    function getConfig(classnames) {

        class GlideJSConfig {
            constructor(type, perView, animationDuration, rewind, gap, breakpoints, focusAt, startAt, peek) {
                this.type = type;
                this.perView = perView;
                this.animationDuration = animationDuration;
                this.rewind = rewind;
                this.gap = gap;
                this.breakpoints = breakpoints;
                this.focusAt = focusAt;
                this.startAt = startAt;
                this.peek = peek;
            }
        }

        if (classnames.includes("services-carousel-glider-html")) {
            return new GlideJSConfig(
                "slider",
                3,
                400,
                false,
                32,
                {
                    1200: {
                        perView: 2,
                        gap: 25,
                    },
                    768: {
                        perView: 1.5,
                        gap: 20,
                    },
                },
                "center",
                0,
                0
            )
        }
        else if (classnames.includes("services-carousel-glider")) {
                    return new GlideJSConfig(
                    "slider",
                    5,
                    400,
                    false,
                    32,
                        {
                            1800: {
                                perView: 4.5,
                                gap: 25,
                            },
                            1500: {
                                perView: 4,
                                gap: 25,
                            },
                            1200: {
                                perView: 3.5,
                                gap: 25,
                            },
                            1024: {
                                perView: 3.5,
                                gap: 20,
                            },
                            835: {
                                perView: 2.5,
                                gap: 20,
                            },
                            500: {
                                perView: 1.75,
                                gap: 20,
                            },
                            400: {
                                perView: 1.5,
                                gap: 20,
                            },
                        },
                "centre",
                    0,
                    0
            )
        }
        else if (classnames.includes("mediumCardGlider")) {
                    return new GlideJSConfig(
                    "slider",
                    1,
                    400,
                    false,
                    20,
                {},
                0,
                    0,
                        {
                            before: 0,
                            after: 20,
                        }
            )
        }
        else if (classnames.includes("cardGridGlider")) {
                    return new GlideJSConfig(
                    "slider",
                    1,
                    400,
                    false,
                    20,
                {},
                0,
                    0,
                        {
                            before: 0,
                            after: 50,
                        }
            )
        }
        else if (classnames.includes("glide-our-plans")) {
                    return new GlideJSConfig(
                    "slider",
                    1,
                    400,
                    false,
                    20,
                {},
                0,
                    0,
                        {
                            before: 5, after: 45
                        }
            )
        }
        else if (classnames.includes("ratingGlider")) {
                    return new GlideJSConfig(
                    "slider",
                    1.5,
                    400,
                    false,
                    20,
                {},
                        "center",
                    0,
                    0
            )
        }
        else if (classnames.includes("calloutGridGlider")) {
                    return new GlideJSConfig(
                    "slider",
                    1,
                    400,
                    false,
                    20,
                {},
                0,
                    0,
                        {
                            before: 50,
                            after: 50
                        }
            )
        }
        else if (classnames.includes("smallCardGlider")) {
                    return new GlideJSConfig(
                    "slider",
                    1,
                    400,
                    false,
                    20,
                {},
                0,
                    0,
                        {
                            before: 0,
                            after: 50
                        }
            )
        }
        else if (classnames.includes("carouselSectionGlider")) {
                    return new GlideJSConfig(
                    "slider",
                    4.5,
                    400,
                    false,
                    34,
                        {
                            1024: {
                                perView: 3.5,
                            },
                            767: {
                                perView: 2.5,
                                gap: 24,
                            },
                            500: {
                                perView: 1.5,
                            },
                        },
                0,
                    0,
                        {
                            before: 0,
                            after: 50
                        }

                    )
        }
        else if (classnames.includes("regionalCardGlider")) {
            return new GlideJSConfig(
                "carousel",
                3,
                400,
                false,
                32,
                {
                    1024: {
                        perView: 1,
                        peek: {
                            before: 50,
                            after: 50
                        }
                    },
                },
                "center",
                0,
                {
                    before: 0,
                    after: 0
                },
            )
        }
        else return {}
    }



    function handleVariablePeek(glider, carouselId, slideSelector) {
        var peek = {
                start: {before: 5, after: 45},
                middle: {before: 30, after: 45},
                end: {before: 30, after: 25}
            }

        var gliderParent = document.querySelector('#' + carouselId)
        var numberOfPlanCards = gliderParent.querySelectorAll(slideSelector).length;

            if (glider.index === 0) {
                return peek.start;
            } else if (glider.index === numberOfPlanCards - 1) {
                return peek.end;
            } else {
                return peek.middle;
            }
    }

    var parentIds = [];

    [...document.querySelectorAll("div[data-glide-parent]")].forEach((carousel) => {
        carousel.id = "glider-parent-" + (parentIds.length + 1).toString();
        parentIds.push(carousel.id);

        var originalChildAnchorTagHrefs = getChildAnchorTagHrefs(carousel);

        var glider = new Glide(carousel, getConfig(carousel.className))
        if(!carousel.className.includes("regionalCardGlider")) {
            glider.on("move.after", function () {
                replaceElementChildAnchorTagHrefs(carousel, originalChildAnchorTagHrefs);
            });
        }

        if(carousel.className.includes("glide-our-plans")) {
            glider.on("run", () => {
                glider.update({peek: handleVariablePeek(glider, carousel.id, ".glide-our-plans .glide__slide")});
            });
        }

        if(carousel.className.includes("productGlider")) {
            //TODO: extract to own function with nice descriptive name
            document.addEventListener('applySelectedSwatchEvent', (e) => {
                const newSwatchImages = e.detail.images;
                document.querySelectorAll('.coop-c-product-carousel__slides li').forEach(el => {
                    el.remove();
                });
                document.querySelectorAll('.coop-c-product-thumbnails__container img').forEach(el => {
                    el.remove();
                });

                newSwatchImages.forEach((image, index) => {
                    const newCarousel = `<li class="glide__slide coop-c-product-carousel__slides__single">
                <picture>
                  <source
                    srcset="${image.url}?fm=webp&amp;q=90&amp;w=1296&amp;fit=fill 1x"
                    type="image/webp"
                  />
                  <img
                    class="coop-c-product__hero"
                    src="${image.url}?w=1296&amp;q=90"
                    data-glide-dir="=${index}"
                    alt="${image.description}"
                  />
                </picture>
              </li>`
                            const newThumbnail = `<img
                src="${image.url}?w=1296&amp;q=90"
                data-glide-dir="=${index}"
                alt="${image.description}"
                class="coop-c-product-thumbnails__single object-fit-polyfill"
              />`;

                            document.querySelector('.coop-c-product-carousel__slides').innerHTML += newCarousel;
                            document.querySelector('.coop-c-product-thumbnails__container').innerHTML += newThumbnail;

                        })
                    })
                }

        glider.mount();

        if(carousel.className.includes("productGlider")) {
            glider.update({startAt: 0})
        }
    });
}
